import { useLazyQuery } from '@apollo/client/react';

import {
  bulkReparseCandidatesQuery,
  BULK_REPARSE_CANDIDATES_LIMIT
} from '../../services/BulkReparseService';

export const useBulkReparseCandidates = () => {
  const [searchCandidates, { loading, data, error }] = useLazyQuery(bulkReparseCandidatesQuery, {
    fetchPolicy: 'network-only'
  });

  return {
    search: (filter) =>
      searchCandidates({ variables: { filter, limit: BULK_REPARSE_CANDIDATES_LIMIT } }),
    loading,
    count: data?.candidates?.count ?? null,
    truncated: data?.candidates?.truncated ?? false,
    items: data?.candidates?.items ?? [],
    error: error ? 'No se pudo calcular la cantidad de documentos. Intentá de nuevo.' : null
  };
};
